<top-menu></top-menu>
<mobile-menu></mobile-menu>
<loader-pane-fragment [trace]="traceNames.viewLogisticsBuild"></loader-pane-fragment> 
<div class="logistics-build">
  <div class="logistics-controls">
    <h5>SELECTED ROOM/LOCATION: </h5>
    <dropdown *ngIf="programOptions?.length" class="program-select" 
      [selections]="programOptions" 
      [selected]="programOptions | findById:selectedProgramId" 
      (select)="setProgramId($event.id)"
    ></dropdown> 
    <div style="flex: 1;"></div>
    <icon [icon]="'grow'" (click)="expandAll()"></icon>
    <icon [icon]="'shrink'" (click)="collapseAll()"></icon>
  </div>

  <div class="program" *ngIf="programs | findById:selectedProgramId as program">
    <expanding-wrapper *ngIf="(program.id + 'venue') as id"
      [title]="'Date and Venue'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [manualToggle]="true"
      [expandedState]="expanded[id] ? 'expand' : 'collapse'"
      (onToggle)="expanded[id] = !expanded[id]"
    >
      <toggle-tab class="header-right desktop"
        (click)="$event.stopPropagation()"
        [bottomTab]="false" 
        [text]="(program.venueConfirmed ? '' : 'NOT ' ) + 'CONFIRMED'"
        [toggled]="!!program.venueConfirmed" (toggle)="toggleVenueConfirmed(program)"
      ></toggle-tab>
      <toggle-tab class="top-of-content mobile"
        (click)="$event.stopPropagation()"
        [bottomTab]="false" 
        [text]="(program.venueConfirmed ? '' : 'NOT ' ) + 'CONFIRMED'"
        [toggled]="!!program.venueConfirmed" (toggle)="toggleVenueConfirmed(program)"
      ></toggle-tab>
      <program-basics *ngIf="!!program && !!event" 
        [event]="event"
        [program]="program"
        [readOnly]="readOnly"
      ></program-basics>
    </expanding-wrapper>

    <expanding-wrapper *ngIf="(program.id + 'assets') as id"
      style="margin-top: 20px; display: block;"
      [title]="'Room/Location Assets'"
      [stackedMobile]="true"
      [borderGreyOnCollapse]="true"
      [manualToggle]="true"
      [expandedState]="expanded[id] ? 'expand' : 'collapse'"
      (onToggle)="expanded[id] = !expanded[id]"
      >
      
      <div class="header-right icon-holder" *ngIf="!expanded[id] && { n: ((program?.assetIds || []) | idsToItems:event.assets).length } as vars">
        <icon-holder *ngIf="!!vars.n" [icon]="'assets'" [count]="vars.n"></icon-holder>
      </div>

      <assets
        [assetIds]="program.assetIds || []" 
        [entityHolderName]="'program'"
        [hideTitle]="true"
        [readOnly]="readOnly"
        (idsAdded)="saveAssetIds($event, program)"
        (idRemoved)="removeAssetId($event, program)"
      ></assets>
    </expanding-wrapper>


    <expanding-wrapper *ngFor="let setup of program.setupIds | idsToItems:program.setups; index as setupIndex; trackBy: trackById" 
      class="centered"
      style="margin-top: 20px; display: block;"
      [borderGreyOnCollapse]="true"
      [manualToggle]="true"
      [stackedMobile]="true"
      [noSpacerLeft]="true"
      [title]="setup.name || ('Unnamed Setup ' + (setupIndex + 1))"
      [expandedState]="expanded[setup.id] ? 'expand' : 'collapse'"
      (onToggle)="expanded[setup.id] = !expanded[setup.id]"
      >
      <div *ngIf="!expanded[setup.id] && !!setup.expected" class="header-middle expected">Expected Numbers: {{ setup.expected }}</div>
      <div *ngIf="!expanded[setup.id] && !!setup.setup" class="header-right setup">Setup: {{ setup.setup }}</div>

      <program-setup
        [setup]="setup" 
        [program]="program"
        [readOnly]="readOnly"
      ></program-setup>
    </expanding-wrapper>
    

    <button class="setup secondary" (click)="addSetup()">+ ADD SETUP</button>

    <expanding-wrapper *ngIf="(program.id + 'stands') as id"
      style="margin-top: 20px; display: block;"
      [title]="'Exhibitor Stands'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [manualToggle]="true"
      [expandedState]="expanded[id] ? 'expand' : 'collapse'"
      (onToggle)="expanded[id] = !expanded[id]"
      >
      <ng-container [ngTemplateOutlet]="exhibitorStandsTemplate" [ngTemplateOutletContext]="{mobile: false}"></ng-container>
      <ng-container [ngTemplateOutlet]="exhibitorStandsTemplate" [ngTemplateOutletContext]="{mobile: true}"></ng-container>
    </expanding-wrapper>
    <expanding-wrapper class="notes" *ngIf="(program.id + 'tags') as id"
      style="margin-top: 20px; display: block;"
      [title]="'Room/Location Tagging'"
      [borderGreyOnCollapse]="true"
      [stackedMobile]="true"
      [manualToggle]="true"
      [expandedState]="expanded[id] ? 'expand' : 'collapse'"
      (onToggle)="expanded[id] = !expanded[id]"
    >

      <div class="header-right icon-holder" *ngIf="!expanded[id]">
        <icon-holder *ngIf="!!tagPanelDatas[program.id]?.count" [count]="tagPanelDatas[program.id]?.count"></icon-holder>
      </div>
      <program-tag-panel *ngIf="!!program" [readOnly]="readOnly" [program]="program"></program-tag-panel>
    </expanding-wrapper> 
    
    <h5 style="margin-top: 20px;">SESSIONS</h5>

    <div class="program-day" *ngFor="let day of program.sessions; trackBy: trackByIndex" >
      <div class="day-date">{{ program | programDayDate:day.day }}</div>
      <ng-container *ngFor="let session of day.sessions | idsToItems:program.sessions_obj; trackBy: trackById">
        <expanding-wrapper class="session centered" 
          [noSpacerLeft]="true"
          [expandedState]="session.type === 'break' ? 'collapse' : expanded[session.id] ? 'expand' : 'collapse'"
          [borderGreyOnCollapse]="true"
          [stackedMobile]="true"
          [manualToggle]="true"
          [hideArrow]="session.type === 'break'"
          (onToggle)="session.type === 'break' ? null : expanded[session.id] = !expanded[session.id]"
        >
          <div class="header-left">
            <div class="time-title ellipsis">
              <div class="time">{{ session.start }} - {{ session.end }}</div>
              <div class="session-title">{{ session.title || 'Unnamed Session' }}</div>
            </div>
            <labels-row (click)="editLabels($event, session, sessionLabelList)" *ngIf="session.type !== 'break'" [labels]="session.labels" [labelMap]="sessionLabelMap" [labelList]="sessionLabelList"></labels-row>
          </div>
          <div class="header-middle ellipsis" [ngClass]="{ labels: session.type !== 'break' }">
            <h5>DURATION:</h5>
            <div class="duration">{{ session.duration }} minutes</div>
          </div>
          <session-status class="header-right labels desktop" (click)="$event.stopPropagation()" *ngIf="session.type !== 'break'" [dotOnly]="false" [programId]="selectedProgramId" [sessionId]="session.id"></session-status>
          <session-status class="top-of-content labels mobile" (click)="$event.stopPropagation()" *ngIf="session.type !== 'break'" [dotOnly]="false" [programId]="selectedProgramId" [sessionId]="session.id"></session-status>
          <div class="empty-div" *ngIf="session.type === 'break'"></div>
          <div class="session-holder" *ngIf="session.type !== 'break'">
            <ng-container [ngTemplateOutlet]="performersTemplate" [ngTemplateOutletContext]="{mobile: false, performerIds: session.performerIds, sessionId: session.id, programId: program.id }"></ng-container>
            <ng-container [ngTemplateOutlet]="performersTemplate" [ngTemplateOutletContext]="{mobile: true, performerIds: session.performerIds, sessionId: session.id, programId: program.id }"></ng-container>
            <ng-container [ngTemplateOutlet]="sponsorsTemplate" [ngTemplateOutletContext]="{mobile: false, sponsorIds: session.sponsorIds, sessionId: session.id }"></ng-container>
            <ng-container [ngTemplateOutlet]="sponsorsTemplate" [ngTemplateOutletContext]="{mobile: true, sponsorIds: session.sponsorIds, sessionId: session.id }"></ng-container>

            <expanding-wrapper *ngIf="(session.id + 'info') as id"
              style="margin-top: 20px; display: block;"
              [title]="'Session Info'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [rightIcon]="!is_program || readOnly ? 'VISIBILITY24' : null"
              [expandedState]="expanded[id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[id] = !expanded[id]"
            >
              <div class="header-right icon-holder" *ngIf="!expanded[id]">
                <icon-holder *ngIf="!!session.description" [icon]="'description18'"></icon-holder>
                <icon-holder *ngIf="!!session.publicLinks?.length" [icon]="'attachment'" [count]="session.publicLinks?.length"></icon-holder>
              </div>
              <div class="session-info">
                <title-icon [title]="'Session description'" titleIcon="description18"></title-icon>
                <input-editor *ngIf="{ notProgram: !is_program || readOnly } as vars"
                  [object]="session" 
                  [prop]="'description'" 
                  [disabled]="vars.notProgram"
                  [placeholder]="vars.notProgram ? 'No description' : 'Click to add a description...'"
                  (changed)="saveSession(session)"
                ></input-editor>
            
                <title-icon class="public-links" [title]="'Public links'" titleIcon="link18"></title-icon>
                <file-handler class="public-links"
                  [readfilesonly]="!is_program || readOnly"
                  [type]="'Public'"
                  [ctaLink]="true"
                  [addText]="'ADD A LINK'"
                  [hideByline]="true"
                  [data]="{ files: session.publicLinks }" 
                  (dataChange)="addPublicLinks($event, session)" 
                ><div class="empty-text" *ngIf="!session.publicLinks?.length">
                  No public links in this session
                </div></file-handler>
              </div>
            </expanding-wrapper>

            <expanding-wrapper *ngIf="(session.id + 'briefNotes') as id"
              style="margin-top: 20px; display: block;"
              [title]="'Notes for Performer Brief'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [rightIcon]="!is_program || readOnly ? 'VISIBILITY24' : null"
              [expandedState]="expanded[id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[id] = !expanded[id]"
            >
              <icon-holder class="header-right" *ngIf="(session.presentationNotes || []).length as n" [count]="n"></icon-holder>
              <editable-notes
                [initClosed]="true"
                [noPadding]="true"
                [readOnly]="!is_program || readOnly"
                [notes]="[{ id: 'presentationNotes', title: 'Presentation notes for performer brief', items: session.presentationNotes, placeholder: 'No notes'}]"
                (onChanges)="saveSession(session)"
              ></editable-notes>
            </expanding-wrapper>

            <expanding-wrapper *ngIf="(session.id + 'assets') as id"
              style="margin-top: 20px; display: block;"
              [title]="'Session Assets'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [rightIcon]="!is_program || readOnly ? 'VISIBILITY24' : null"
              [expandedState]="expanded[id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[id] = !expanded[id]"
            >
              <icon-holder class="header-right" *ngIf="((session.assetIds || []) | idsToItems:event.assets).length as n" [icon]="'assets'" [count]="n"></icon-holder>
              <assets
                [title]="'Session Assets'"
                [assetIds]="session.assetIds || []" 
                [readOnly]="readOnly || event?.is_readonly"
                (idsAdded)="addSessionAssetIds($event, session)"
                (idRemoved)="removeSessionAssetId($event, session)"
              ></assets>
            </expanding-wrapper>

            <expanding-wrapper class="requests" *ngIf="{ id: session.id + 'requests', requests: stagingRequestsBySessionId[session.id] || [] } as vars"
              style="margin-top: 20px; display: block;"
              [title]="'Staging requests'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [expandedState]="expanded[vars.id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[vars.id] = !expanded[vars.id]"
            >
              <icon-holder class="header-right" *ngIf="!expanded[vars.id] && vars.requests?.length" [icon]="'clipboard_question18'" [count]="vars.requests.length"></icon-holder>
              <div class="staging-requests">
                <title-icon style="margin-top: 20px; display: block;" [title]="'Staging requests'" [titleIcon]="'clipboard_question18'"></title-icon>
                <div *ngIf="!vars.requests?.length" class="empty-text">No staging requests.</div>
                <staging-requests *ngIf="!!vars.requests?.length" [stagingRequests]="vars.requests"></staging-requests>
              </div>
            </expanding-wrapper>

            <expanding-wrapper class="notes" *ngIf="(session.id + 'notes') as id"
              style="margin-top: 20px; display: block;"
              [title]="'Staging Notes'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [expandedState]="expanded[id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[id] = !expanded[id]"
            >
              <div class="header-right icon-holder" *ngIf="!expanded[id]">
                <icon-holder *ngIf="!!session.notes" [icon]="'description18'"></icon-holder>
                <icon-holder *ngIf="!!session.stagingItems?.length" [icon]="'event_information18'" [count]="session.stagingItems?.length"></icon-holder>
                <icon-holder *ngIf="!!session.files?.length" [icon]="'attachment'" [count]="session.files?.length"></icon-holder>
              </div>

              <logistics-session-inlay
                [readOnly]="readOnly || !is_program"
                [session]="session"
                (saveSession)="saveSession(session)"
              ></logistics-session-inlay>
            </expanding-wrapper>

            <expanding-wrapper class="notes" *ngIf="(session.id + 'catering') as id"
              style="margin-top: 20px; display: block;"
              [title]="'Catering Notes'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [expandedState]="expanded[id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[id] = !expanded[id]"
            >
            <div class="header-right icon-holder" *ngIf="!expanded[id]">
              <icon-holder *ngIf="!!session.cateringNotes" [icon]="'description18'"></icon-holder>
              <icon-holder *ngIf="!!session.cateringItems?.length" [icon]="'event_information18'" [count]="session.cateringItems?.length"></icon-holder>
              <icon-holder *ngIf="!!session.cateringFiles?.length" [icon]="'attachment'" [count]="session.cateringFiles?.length"></icon-holder>
            </div>
              <logistics-session-inlay
                [readOnly]="readOnly || !is_program"
                [session]="session"
                (saveSession)="saveSession(session)"
                [type]="'catering'"
                [filesKey]="'cateringFiles'"
                [notesKey]="'cateringNotes'"
                [itemsKey]="'cateringItems'"
              ></logistics-session-inlay>
            </expanding-wrapper>

            <expanding-wrapper class="notes" *ngIf="(session.id + 'tags') as id"
              style="margin-top: 20px; display: block;"
              [title]="'Session Tagging'"
              [borderGreyOnCollapse]="true"
              [stackedMobile]="true"
              [manualToggle]="true"
              [expandedState]="expanded[id] ? 'expand' : 'collapse'"
              (onToggle)="expanded[id] = !expanded[id]"
            >
              <div class="header-right icon-holder" *ngIf="!expanded[id]">
                <icon-holder *ngIf="!!tagPanelDatas[session.id]?.count" [count]="tagPanelDatas[session.id]?.count"></icon-holder>
              </div>
              <session-tag-panel *ngIf="!!session" [readOnly]="readOnly" [session]="session" [programId]="program.id"></session-tag-panel>
            </expanding-wrapper> 

        
          </div>
        </expanding-wrapper>
      </ng-container>
      
    </div>
  </div>
</div>

<ng-template #sponsorsTemplate let-mobile="mobile" let-sessionId="sessionId" let-sponsorIds="sponsorIds">
  <sponsors [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [displayType]="mobile ? sponsorDisplayTypes.narrowPod : sponsorDisplayTypes.widePod"
    [readOnly]="!is_program || readOnly"
    [sessionId]="sessionId"
    [sponsorIds]="sponsorIds"
    [emptyText]="'No sponsors in this session'"
  ></sponsors>
</ng-template>

<ng-template #performersTemplate let-mobile="mobile" let-performerIds="performerIds" let-sessionId="sessionId", let-programId="programId">
  <performers [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [showBriefStatus]="true"
    [programId]="programId"
    [performerIds]="performerIds"
    [displayType]="mobile ? performerDisplayTypes.narrowPod : performerDisplayTypes.widePod"
    [readOnly]="!is_program || readOnly"
    [fromManageDialog]="true"
    [sessionId]="sessionId"
    [emptyText]="'No performers in this session'"
  ></performers>
</ng-template>

<ng-template #exhibitorStandsTemplate let-mobile="mobile">
  <exhibitor-stands [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [showBriefStatus]="true"
    [hideTitle]="true"
    [displayType]="mobile ? exhibitorDisplayTypes.narrowPod : exhibitorDisplayTypes.widePod"
    [readOnly]="readOnly"
    [programId]="selectedProgramId"
    [emptyText]="'No exhibitor stands in this program'"
  ></exhibitor-stands>
</ng-template>